module.exports = __webpack_public_path__ + "assets/tenbisCard-1f107a.svg";